import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function unidade(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@unidade/FIND_UNIDADE':
      case '@unidade/UPDATE_UNIDADE':
      case '@unidade/DELETE_UNIDADE':
      case '@unidade/STORE_UNIDADE':
      case '@unidade/UNIDADES_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@unidade/SUCCESS_REMOVE':
      case '@unidade/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@unidade/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.unidades;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@unidade/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.unidade;
        break;
      }

      case '@unidade/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
